const axiosGetNewsList = async (parent, slug, pageNumber) => {
  const action = parent.querySelector('[data-action]').value;
  const initialCategoryData = parent.querySelector('[data-initial]').value;
  const newsList = parent.querySelector('.news-list__list');
  const noResultElem = parent.querySelector('.news-list__not-found');
  const newsListFooter = parent.querySelector('.news-list__footer');
  const featureNews = parent.querySelector('.news-list-container');

  const formDataInput = {
    action,
    slug,
    initialCategoryData,
    pageNumber,
    newsCategory: slug,
    nonce: await getNonceForAction(action),
  };

  try {
    const { data } = await axios.post(localData.siteURL, formDataInput);
    newsList.innerHTML = '';

    if (newsList && data.data.html_list) {
      newsList.innerHTML = data.data.html_list;
      noResultElem.classList.add('hide');
    }

    if (noResultElem && !data.data.html_list) {
      noResultElem.classList.remove('hide');
    }

    if (featureNews && data.data.html_feature) {
      featureNews.innerHTML = data.data.html_feature;
      featureNews.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    if (newsListFooter && data.data.html_pagination) {
      newsListFooter.innerHTML = data.data.html_pagination;
    }

    const [baseUrl] = window.location.href.split('?');
    const urlParams = ['newsCategory', 'pageNumber']
      .filter((item) => formDataInput[item] && formDataInput[item].length > 0)
      .map((item) => `${item}=${formDataInput[item]}`)
      .join('&');

    window.history.pushState({}, '', baseUrl + (urlParams ? `?${urlParams}` : ''));
  } catch (err) {
    console.error(err);
  }
};

attachEvent('.news-list__filter .mod-tag', 'click', ({ target }) => {
  const dataSlug = target.getAttribute('data-slug');
  const parent = target.closest('.news-list');

  // Toggle active class on buttons
  const preselectedBtn = parent.querySelector('.mod-tag.is-active');
  toggleActiveClass(preselectedBtn, false);
  toggleActiveClass(target, true);

  // Filter AJAX Call
  axiosGetNewsList(parent, dataSlug, 1);
});

// Pagination
attachEvent('.news-list .pagination .pagination__number', 'click', (ev) => {
  ev.preventDefault();
  const parent = ev.target.closest('.news-list');
  const selectedCategory = parent.querySelector('.news-list__filter-item .is-active');
  const dataSlug = selectedCategory?.getAttribute('data-slug');
  const pageNumber = ev.target.dataset.page;
  axiosGetNewsList(parent, dataSlug, pageNumber);
});
